<template>
  <div>
    <div class="info-title">
      <p class="text-doc">For editing your DoveMed profile, please visit your profile.</p>
      <!-- <p class="text-doc">Edit additional information on your DoveMed physician profile.</p> -->
      <a-button class="profile-btn" @click="GotoPhyProfile">Visit Profile</a-button>
    </div>
    <div v-for="(cardValue, cardKey, index) in cardKeys" :key="index">
      <div class="dovemed-card-noborder bottom-space" v-if="cardKey === 'about'">
        <div style="display: flex; justify-content: space-between">
          <p class="title">{{ cardKey | humanize }} {{ "you" }}</p>
        </div>
        <p v-if="!cardValue" :style="{ overflow: 'auto', 'line-height': '32px', 'font-size': '16px', color: '#647490' }">
          {{ profileData[cardKey] }}
        </p>
        <a-textarea v-model="profileData[cardKey]" :rows="4" v-if="cardValue" class="editable-textarea" />
        <button class="dovemed-button primary-border font-primary ml-4" v-if="cardValue" @click="save(cardKey)">Save</button>
        <button class="dovemed-button primary-border font-primary ml-4" v-if="cardValue" @click="cancelEditable(cardKey)">Cancel</button>

        <!-- <div :style="{ 'margin-top': '80px' }">
          <DoctorAboutReview :refId="profileData.ext_ref_id" :IsOwnerView="true" />
        </div> -->

        <div :style="{ 'margin-top': '80px' }">
          <DoctorAboutReview :refId="profileData.ext_ref_id" :IsOwnerView="true" :revType="'In Person Visit'" :avgRating="parseFloat(profileData.overall_rating || '0')" />
        </div>

        <div :style="{ 'margin-top': '80px' }">
          <DoctorAboutReview :refId="profileData.ext_ref_id" :IsOwnerView="true" :revType="'Telemedicine'" :avgRating="parseFloat(profileData.online_type_rating || '0')" />
        </div>

        <div :style="{ 'margin-top': '80px' }">
          <DoctorAboutReview :refId="profileData.ext_ref_id" :IsOwnerView="true" :revType="'MyCircles'" :avgRating="parseFloat(profileData.mycircles_type_rating || '0')" />
        </div>

        <div :style="{ 'margin-top': '80px' }">
          <DoctorAboutRecommend :refId="profileData.ext_ref_id" :IsOwnerView="true" />
        </div>
      </div>
      <div class="dovemed-card-noborder bottom-space" v-if="cardKey === 'language_spoken' && profileData[cardKey].length > 0">
        <p class="title">
          {{ profileData[cardKey].length > 1 ? "Languages Spoken" : cardKey | humanize }}
          {{ profileData[cardKey] | total }}
        </p>
        <div class="language d-flex" :style="{ overflow: 'auto' }">
          <div v-for="(language, index) in profileData[cardKey]" :key="index" class="mono-language">
            <img :src="language.icon" />
            <p>{{ language.language }}</p>
          </div>
        </div>
      </div>
      <div class="dovemed-card-noborder bottom-space" v-if="cardKey === 'interested_areas' && profileData[cardKey].length > 0" :style="{ gap: '16px' }">
        <p class="title">{{ cardKey | humanize }} {{ profileData[cardKey] | total }}</p>
        <div class="language d-flex">
          <div v-for="(area, index) in profileData[cardKey]" :key="index" class="mono-area">
            <img :src="area.icon" />
            <p>{{ area.name }}</p>
          </div>
        </div>
      </div>
      <div class="dovemed-card-noborder bottom-space" v-if="cardKey === 'conditions_treated' && profileData[cardKey].length > 0">
        <p class="title">{{ cardKey | humanize }} {{ profileData[cardKey] | total }}</p>
        <div>
          <ul :style="{ '--P500C': getPrimaryColor().split(' ')[0] }" class="primary-clr-list-bullets">
            <li v-for="(item, index) in profileData[cardKey]" :key="index">
              <a :style="item.link && { color: '#0e72ba !important' }" :class="`ml-2 ${item.link ? '' : 'noUnderline'}`" target="_blank" :href="item.link">{{ item.condition }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="dovemed-card-noborder bottom-space" v-if="cardKey === 'procedures_performed' && profileData[cardKey].length > 0">
        <p class="title">{{ cardKey | humanize }} {{ profileData[cardKey] | total }}</p>
        <div>
          <ul :style="{ '--P500C': getPrimaryColor().split(' ')[0] }" class="primary-clr-list-bullets">
            <li v-for="(item, index) in profileData[cardKey]" :key="index">
              <a :class="`ml-2 ${item.link ? '' : 'noUnderline'}`" :style="item.link && { color: '#0e72ba !important' }" target="_blank" :href="item.link">{{ item.procedure }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="dovemed-card-noborder bottom-space" v-if="cardKey === 'accepted_insurance' && profileData[cardKey].length > 0">
        <p class="title">Insurance carriers {{ profileData[cardKey] | total }}</p>
        <div class="language d-flex">
          <div v-for="(item, index) in profileData[cardKey]" :key="index" class="mono-insurance">
            <p>{{ item.carrier }}</p>
          </div>
        </div>
        <p v-if="profileData[cardKey].length > 0" class="insurance-sub">
          The insurance(s) accepted by the healthcare provider may change from time to time. We urge you to check with the physician’s office to requesting an appointment.
        </p>
      </div>
      <div class="dovemed-card-noborder bottom-space" v-if="cardKey === 'hospital_affiliations' && profileData[cardKey].length > 0">
        <p class="title">{{ cardKey | humanize }} {{ profileData | total }}</p>
        <div>
          <div v-for="(item, index) in profileData[cardKey]" :key="index">
            <div class="dovemed-card d-flex hospital-card-mobile hospital-card" :style="{ 'margin-bottom': '24px' }">
              <div>
                <img class="mr-4 hospital_picture" :src="item.picture" />
              </div>
              <hr class="divider-line" />
              <div class="hospital-card-mobile d-flex flex-direction-row">
                <div>
                  <p class="hosp-name">{{ item.hospital_name }}</p>
                  <span class="hospital_tag" :style="{ color: getPrimaryColor(), background: getPrimary50Color(), 'margin-bottom': '0px' }">
                    {{ item.hospital_type }}
                  </span>
                </div>
                <div class="d-flex flex-column web-style">
                  <div class="d-flex flex-row">
                    <img class="hw20 br0" src="../../../assets/images/addphy-phone.png" alt="phone-logo" />
                    <p :style="{ 'padding-left': '6px', color: ' #0F1734', 'font-weight': '700' }">
                      {{ item.phone_number }}
                    </p>
                  </div>
                  <div class="d-flex flex-row align-items-center">
                    <img :style="{ width: '15px', height: '20px' }" src="../../../assets/images/addphy-location.png" alt="location" />
                    <div :style="{ 'padding-left': '6px', color: '#94A3B8' }">
                      <p class="mb-0">{{ item.city }}, {{ item.state }}</p>
                      <p class="mb-0">{{ item.street }}</p>
                    </div>
                  </div>
                  <div>
                    <p></p>
                  </div>
                </div>
                <div :style="{ display: 'flex', 'align-items': 'center' }">
                  <a-button :style="{ background: getPrimaryColor(), color: '#fff' }" class="view-profile mobile-width" @click="dovemedUrl(item.url)">View Profile</a-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dovemed-card-noborder" v-if="cardKey === 'educational_qualifications'">
        <p class="title">{{ cardKey | humanize }}</p>
        <div v-for="(itemValue, itemKey, ItemIndex) in profileData[cardKey]" :key="ItemIndex">
          <div :header="itemKey" :key="ItemIndex">
            <div v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue" :key="nestItemIndex">
              <p v-if="nestItemValue">{{ nestItemKey | humanize(false) }}: {{ nestItemValue }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="dovemed-card-noborder bottom-space" v-if="cardKey === 'board_certifications' && profileData[cardKey].length > 0">
        <p class="title">{{ cardKey | humanize }}</p>
        <div v-for="(item, ItemIndex) in profileData[cardKey]" :key="ItemIndex">
          <!-- <div :header="itemKey" :key="ItemIndex">
            <div
              v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue"
              :key="nestItemIndex"
            >
              <p v-if="typeof nestItemValue === 'string'">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue }}
              </p>
              <p v-else-if="nestItemValue && nestItemValue.name">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue.name }}
                <img
                  :width="25"
                  v-if="nestItemValue.icon"
                  :src="nestItemValue.icon"
                />
              </p>
            </div>
          </div> -->
          <div class="m-3 board-certification mobile-margin">
            <div class="left">
              <div class="img-back">
                <img v-if="item.speciality && item.speciality.icon" :src="item.speciality.icon" alt="certification-icon" style="transform: scale(0.7)" />
              </div>
            </div>
            <div class="divider"></div>

            <div class="right">
              <span :style="{ 'font-size': '20px', 'line-height': '30px', color: ' #0F1734' }">
                <b>{{ item.speciality.name || "N/A" }}</b>
              </span>
              <span :style="{ 'font-size': '16px', 'line-height': '24px', color: ' #0F1734' }">{{ item.accreditation.name || "N/A" }}</span>
              <span>
                Certification:{{ moment(item.initial_date).format("YYYY") || "N/A" }}
                -
                {{ item.expire_date ? moment(item.expire_date).format("YYYY") : "N/A" }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="dovemed-card-noborder bottom-space" v-if="cardKey === 'state_licensure' && profileData[cardKey].length > 0">
        <p class="title">State License {{ profileData | total }}</p>
        <div class="d-flex state">
          <div class="d-flex state-license" v-for="(item, index) in profileData[cardKey]" :key="index">
            <div :style="{ padding: '24px' }">
              <!-- <p v-if="item.license_number">
                <b>License Number:</b> {{ item.license_number }}
              </p>
              <p><b>State:</b> {{ item.state }}</p>
              <p>
                <b>Status:</b>
                <span>{{ item.is_active ? "Active" : "Inactive" }}</span>
              </p>
              <p v-if="item.issue_date">
                <b>Affiliation Date:</b> <span>{{ item.issue_date }}</span>
              </p>
              <p v-if="item.expire_date">
                <b>Expiry Date:</b> <span>{{ item.expire_date }}</span>
              </p> -->
              <div class="location">
                <!-- <div></div> -->
                <div class="state-name">{{ item.state }}</div>
              </div>
              <div class="d-flex state-license--status">
                <!-- <div class="d-flex  left">Status:</div> -->
                <div class="d-flex flex-row right align-items-center" :style="{ 'margin-left': '0px', 'padding-left': '0px', gap: '0px' }">
                  <span class="status-circle" :style="{ background: item.is_active ? '#6dd400' : '#98A9BB' }"></span>
                  <span class="status-state" :style="{ color: item.is_active ? '#6dd400' : '#98A9BB' }">{{ item.is_active ? "Active" : "Inactive" }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dovemed-card-noborder bottom-space" v-if="cardKey === 'academic_affiliations' && profileData[cardKey].length > 0">
        <p class="title">{{ cardKey | humanize }} {{ profileData | total }}</p>
        <div>
          <div v-for="(item, index) in profileData[cardKey]" :key="index">
            <div class="dovemed-card d-flex flex-row">
              <div class="left">
                <div class="img-back">
                  <a-avatar
                    class="post-list-image text-capitalize"
                    :style="{ color: '#ffffff', 'background-color': getPrimaryColor()}"
                    :size="70"
                    :src="null"
                    alt="avatar"
                  >
                    {{ item.name_of_organization[0] }}
                  </a-avatar>
                </div>
              </div>
              <div class="divider-line"></div>
              <div class="d-flex flex-column">
                <div class="d-flex">
                  <p v-if="item.from_date">
                    <span>{{ moment(item.from_date).format("YYYY") }}</span>
                  </p>
                  <p v-if="item.currently_affiliated">- Currently</p>
                  <p v-if="item.to_date">
                    <span> -{{ moment(item.to_date).format("YYYY") }}</span>
                  </p>
                </div>
                <p>
                  <b>{{ item.name_of_organization }}</b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="dovemed-card-noborder bottom-space"
      v-if="
        profileData &&
          (profileData['medical_school'].length > 1 ||
            profileData['internship'].length > 1 ||
            profileData['residency'].length > 1 ||
            profileData['chief_residency'].length > 1 ||
            profileData['other_education'].length > 1 ||
            profileData['fellowship'].length > 1)
      "
    >
      <p class="title">Education Qualifications</p>
      <div class="dovemed-card-noborder" v-if="profileData['medical_school'].length > 1" :style="{ 'margin-bottom': '48px' }">
        <p class="sub-title">{{ "Medical School" }}</p>
        <div class="dovemed-card">
          <div v-for="(item, index) in profileData['medical_school']" :key="index" class="d-flex flex-row">
            <div class="left" v-if="item.university">
              <div class="img-back">
                <img :src="profileData['medical_school'][1].image" alt="certification-icon" />
              </div>
            </div>
            <div v-if="item.university" class="divider-line"></div>
            <div v-if="item.university">
              <p v-if="item.year_of_completion">
                {{ moment(item.year_of_completion).format("YYYY") }}
              </p>
              <p v-if="item.university" class="degree">
                {{ item.university.name }}
              </p>
              <div class="d-flex flex-row">
                <p v-if="item.city">{{ item.city }}</p>
                <p v-if="item.state">{{ "," }} {{ item.state }}</p>
                <p v-if="item.country">{{ (",", item.country.code) }}</p>
              </div>
              <p v-if="item.degrees">
                Academic Awarded:<b> {{ item.degrees }} </b>
              </p>
              <p v-if="item.academic_awards">
                Academic Awards & Achievements :
                <b>{{ item.academic_awards }}</b>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- internship -->
    <div class="dovemed-card-noborder" v-if="profileData && profileData['internship'] && profileData['internship'].length > 1" :style="{ 'margin-bottom': '48px' }">
      <p class="sub-title">{{ "Internship" }}</p>
      <div class="dovemed-card">
        <div v-for="(item, itemKey, ItemIndex) in profileData['internship']" :key="ItemIndex" class="d-flex flex-row">
          <div v-if="Object.keys(item).length > 1" class="d-flex flex-row">
            <!-- <div
              v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue"
              :key="nestItemIndex"
            >
              <img
                v-if="nestItemKey === 'imagge'"
                :src="nestItemValue"
                alt=""
              />
              <p v-if="typeof nestItemValue === 'string'">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue }}
              </p>
              <p v-else-if="nestItemValue && nestItemValue.name">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue.name }}
                <img
                  :width="25"
                  v-if="nestItemValue.icon"
                  :src="nestItemValue.icon"
                />
              </p>
            </div> -->

            <div class="left" v-if="item.university">
              <div class="img-back">
                <img
                  v-if="profileData['internship'][profileData['internship'].length - 1].image"
                  :src="profileData['internship'][profileData['internship'].length - 1].image"
                  alt="certification-icon"
                  style="transform: scale(0.7)"
                />
              </div>
            </div>
            <div v-if="item.university" class="divider-line"></div>
            <div v-if="item.university">
              <div class="d-flex flex-row">
                <p v-if="item.from_date">
                  {{ moment(item.from_date).format("YYYY") }}
                </p>
                <p v-if="item.to_date">
                  {{ (",", moment(item.to_date).format("YYYY")) }}
                </p>
              </div>

              <p v-if="item.university" class="degree">
                {{ item.university.name }}
              </p>
              <div class="d-flex flex-row">
                <p v-if="item.city">{{ item.city }}</p>
                <p v-if="item.state">{{ "," }} {{ item.state }}</p>
                <p v-if="item.country">{{ (",", item.country.code) }}</p>
              </div>
              <p v-if="item.physician_speciality">
                Speciality:<b>{{ item.physician_speciality.name }} </b>
                <img :src="item.physician_speciality.icon" width="30px" height="30px" v-if="item.physician_speciality.icon" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- residency -->
    <div class="dovemed-card-noborder bottom-space" v-if="profileData && profileData['residency'] && profileData['residency'].length" :style="{ 'margin-bottom': '48px' }">
      <p class="sub-title">{{ "Residency" }}</p>
      <div class="dovemed-card">
        <div v-for="(item, itemKey, ItemIndex) in profileData['residency']" :key="ItemIndex">
          <div v-if="Object.keys(item).length > 1" class="d-flex flex-row">
            <!-- <div
              v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue"
              :key="nestItemIndex"
            >
              <img v-if="nestItemKey === 'image'" :src="nestItemValue" alt="" />
              <p v-if="typeof nestItemValue === 'string'">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue }}
              </p>
              <p v-else-if="nestItemValue && nestItemValue.name">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue.name }}
                <img
                  :width="25"
                  v-if="nestItemValue.icon"
                  :src="nestItemValue.icon"
                />
              </p>
            </div> -->

            <div class="left" v-if="item.university">
              <div class="img-back">
                <img
                  v-if="profileData['residency'][profileData['residency'].length - 1].image"
                  :src="profileData['residency'][profileData['residency'].length - 1].image"
                  alt="certification-icon"
                  style="transform: scale(0.7)"
                />
              </div>
            </div>
            <div v-if="item.university" class="divider-line"></div>
            <div v-if="item.university">
              <div class="d-flex flex-row">
                <p v-if="item.from_date">
                  {{ moment(item.from_date).format("YYYY") }}
                </p>
                <p v-if="item.to_date">
                  {{ "-" + moment(item.to_date).format("YYYY") }}
                </p>
              </div>

              <p v-if="item.university" class="degree">
                {{ item.university.name }}
              </p>
              <div class="d-flex flex-row">
                <p v-if="item.city">{{ item.city }}</p>
                <p v-if="item.state">{{ "," }} {{ item.state }}</p>
                <p v-if="item.country">{{ (",", item.country.code) }}</p>
              </div>
              <p v-if="item.physician_speciality">
                Speciality:<b>{{ item.physician_speciality.name }} </b>
                <img :src="item.physician_speciality.icon" width="30px" height="30px" v-if="item.physician_speciality.icon" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- chief_residency -->
    <div class="dovemed-card-noborder" v-if="profileData && profileData['chief_residency'].length > 1" :style="{ 'margin-bottom': '48px' }">
      <p class="sub-title">{{ "Chief Residency" }}</p>
      <div class="dovemed-card">
        <div v-for="(item, itemKey, ItemIndex) in profileData['chief_residency']" :key="ItemIndex">
          <div v-if="Object.keys(item).length > 1" class="d-flex flex-row">
            <!-- <div
              v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue"
              :key="nestItemIndex"
            >
              <img v-if="nestItemKey === 'image'" :src="nestItemValue" alt="" />
              <p v-if="typeof nestItemValue === 'string'">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue }}
              </p>
              <p v-else-if="nestItemValue && nestItemValue.name">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue.name }}
                <img
                  :width="25"
                  v-if="nestItemValue.icon"
                  :src="nestItemValue.icon"
                />
              </p>
            </div> -->

            <div class="left" v-if="item.university">
              <div class="img-back">
                <img
                  v-if="profileData['chief_residency'][profileData['chief_residency'].length - 1].image"
                  :src="profileData['chief_residency'][profileData['chief_residency'].length - 1].image"
                  alt="certification-icon"
                  style="transform: scale(0.7)"
                />
              </div>
            </div>
            <div v-if="item.university" class="divider-line"></div>
            <div v-if="item.university">
              <div class="d-flex flex-row">
                <p v-if="item.date_from">
                  {{ moment(item.date_from).format("YYYY") }}
                </p>
                <p v-if="item.date_to">
                  {{ "-" + moment(item.date_to).format("YYYY") }}
                </p>
              </div>

              <p v-if="item.university" class="degree">
                {{ item.university.name }}
              </p>
              <div class="d-flex flex-row">
                <p v-if="item.city">{{ item.city }}</p>
                <p v-if="item.state">{{ "," }} {{ item.state }}</p>
                <p v-if="item.country">{{ (",", item.country.code) }}</p>
              </div>
              <p v-if="item.physician_speciality">
                Speciality:<b>{{ item.physician_speciality.name }} </b>
                <img :src="item.physician_speciality.icon" width="30px" height="30px" v-if="item.physician_speciality.icon" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- other_education -->
    <div class="dovemed-card-noborder" v-if="profileData['other_education'].length > 1" :style="{ 'margin-bottom': '48px' }">
      <p class="sub-title">{{ "Other Education" }}</p>
      <div class="dovemed-card">
        <div v-for="(item, itemKey, ItemIndex) in profileData['other_education']" :key="ItemIndex">
          <div v-if="Object.keys(item).length > 1" class="d-flex flex-row">
            <div class="left" v-if="item.university">
              <div class="img-back">
                <img
                  v-if="profileData['other_education'][profileData['other_education'].length - 1].imagge"
                  :src="profileData['other_education'][profileData['other_education'].length - 1].imagge"
                  alt="certification-icon"
                  style="transform: scale(0.7)"
                />
              </div>
            </div>
            <div v-if="item.university" class="divider-line"></div>
            <div v-if="item.university">
              <div class="d-flex flex-row">
                <p v-if="item.date_from">
                  {{ moment(item.date_from).format("YYYY") }}
                </p>
                <p v-if="item.date_to">
                  {{ "-" + moment(item.date_to).format("YYYY") }}
                </p>
              </div>

              <p v-if="item.university" class="degree">
                {{ item.university.name }}
              </p>
              <div class="d-flex flex-row">
                <p v-if="item.city">{{ item.city }}</p>
                <p v-if="item.state">{{ "," }} {{ item.state }}</p>
                <p v-if="item.country">{{ (",", item.country.code) }}</p>
              </div>
              <p v-if="item.physician_speciality">
                Speciality:<b>{{ item.physician_speciality.name }} </b>
                <img :src="item.physician_speciality.icon" width="30px" height="30px" v-if="item.physician_speciality.icon" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- fellowship -->
    <div class="dovemed-card-noborder" v-if="profileData['fellowship'].length > 1" :style="{ 'margin-bottom': '48px' }">
      <p class="sub-title">{{ "Fellowship" }}</p>
      <div class="dovemed-card">
        <div v-for="(item, itemKey, ItemIndex) in profileData['fellowship']" :key="ItemIndex">
          <div v-if="Object.keys(item).length > 1" class="d-flex flex-row">
            <!-- <div
              v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue"
              :key="nestItemIndex"
            >
              <img v-if="nestItemKey === 'image'" :src="nestItemValue" alt="" />
              <p v-if="typeof nestItemValue === 'string'">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue }}
              </p>
              <p v-else-if="nestItemValue && nestItemValue.name">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue.name }}
                <img
                  :width="25"
                  v-if="nestItemValue.icon"
                  :src="nestItemValue.icon"
                />
              </p>
            </div> -->

            <div class="left" v-if="item.university">
              <div class="img-back">
                <img
                  v-if="profileData['fellowship'][profileData['fellowship'].length - 1].image"
                  :src="profileData['fellowship'][profileData['fellowship'].length - 1].image"
                  alt="certification-icon"
                  style="transform: scale(0.7)"
                />
              </div>
            </div>
            <div v-if="item.university" class="divider-line"></div>
            <div v-if="item.university">
              <div class="d-flex flex-row">
                <p v-if="item.date_from">
                  {{ moment(item.date_from).format("YYYY") }}
                </p>
                <p v-if="item.date_to">
                  {{ "-" + moment(item.date_to).format("YYYY") }}
                </p>
              </div>

              <p v-if="item.university" class="degree">
                {{ item.university.name }}
              </p>
              <div class="d-flex flex-row">
                <p v-if="item.city">{{ item.city }}</p>
                <p v-if="item.state">{{ "," }} {{ item.state }}</p>
                <p v-if="item.country">{{ (",", item.country.code) }}</p>
              </div>
              <p v-if="item.physician_speciality">
                Speciality:<b>{{ item.physician_speciality.name }} </b>
                <img :src="item.physician_speciality.icon" width="30px" height="30px" v-if="item.physician_speciality.icon" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import DoctorAboutRecommend from "./view/DoctorAboutRecommend.vue"
import DoctorAboutReview from "./view/DoctorAboutReview.vue"
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "DocAbout",
  components: {
    DoctorAboutRecommend,
    DoctorAboutReview,
  },
  data() {
    return {
      cardKeys: null,
      profileData: null,
      toDeleteKeys: [
        "id",
        "created_at",
        "updated_at",
        "is_deleted",
        "user",
        "is_verified",
        "npi_number",
        "state_licence",
        "licence_number",
        "display_name",
        "rec_description",
        "rec_option",
        "rec_user",
        "rec_user_circle",
        "recommendations",
        "user_circle",
      ],
      // test: null
      status: false,
    }
  },
  created() {
    console.warn("DoctorAbout.vue created")
    this.fetchData()
  },

  methods: {
    /**
     * Fetch user profile data
     */
    async fetchData() {
      const data = await UserRepository.getAbout(this.authUser.user, this.currentCircle.id)

      this.profileData = data.data.data ? data.data.data[0] : {}
      console.log("fetchData() -> profileData:", this.profileData)

      let profileDataCopy = { ...this.profileData }
      this.toDeleteKeys.forEach(key => {
        delete profileDataCopy[key]
      })
      // const keys = Object.keys(profileDataCopy)
      const keys = Object.keys(profileDataCopy)
      this.cardKeys = this.makeKeys(keys)
      // console.log(this.cardKeys, "cardkeys")
      this.status = true
    },

    makeKeys(cardKeys) {
      let editableKeys = {}
      for (var key in cardKeys) {
        if (cardKeys.hasOwnProperty(key)) {
          editableKeys[cardKeys[key]] = false
        }
      }
      return editableKeys
    },
    GotoPhyProfile() {
      window.open(`${process.env.SSO_BASE_URL}/ratings/physician/${this.authUser.user.ext_ref_id}-${this.authUser.user.first_name}-${this.authUser.user.last_name.split(" ").join("-")}`, "_blank")
    },
    dovemedUrl(url) {
      window.open(`${process.env.SSO_BASE_URL}${url}`, "_blank")
    },
  },

  filters: {
    humanize: function(value, capitalize = false) {
      if (!value) return ""
      return capitalize
        ? value
            .toLowerCase()
            .split("_")
            .map(e => e.toUpperCase())
            .join(" ")
        : value
            .toLowerCase()
            .split("_")
            .map(e => e.charAt(0).toUpperCase() + e.substring(1))
            .join(" ")
    },

    total: function(value, ...options) {
      if (!value) return ""
      return Array.isArray(value) ? `(${value.length})` : ""
    },
  },
}
</script>

<style lang="scss" scoped>
.state-name {
  font-size: 20px;
  line-height: 30px;
  color: #1e2945;
}

.web-style {
  @media screen and (min-width: 600px) {
    width: 213px;
    margin-right: 24px;
  }
  @media screen and (max-width: 600px) {
    margin-top: 16px;
  }
}
@media screen and (max-width: 900px) {
  .hospital-card-mobile {
    display: flex;
    flex-direction: column;
  }
  .hospital_tag {
    margin-bottom: 16px !important;
  }
  .mobile-width {
    max-width: 186px !important;
  }
  .mobile-margin {
    margin: 0px !important;
  }

  .dovemed-card-noborder {
    .language {
      margin-left: 0px !important;
    }
  }
}

.hospital-card {
  flex-direction: row;
}

.degree {
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #0f1734;
}
.divider-line {
  height: auto;
  padding-bottom: 0px;
  width: 0px;
  border: 1px solid #cbd5e1;
  margin-top: -20px;
  margin-bottom: -20px;
  margin-right: 24px;
  margin-left: 0px;
  background: #cbd5e1;
}
.bottom-space {
  margin-bottom: 80px !important;
}

.text-doc {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #33415f !important;
  text-align: center;
}
.info-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 16px;
  background: #f1f5f9;
  margin-bottom: 80px;
}
.profile-btn {
  padding: 8px 16px;
  background: #062b54;
  border-radius: 6px;
  display: flex;
  align-items: center;
}
.about-card {
  overflow: auto;
  padding: 0px !important;
  box-shadow: none;
}
.about-card::-webkit-scrollbar {
  width: 0; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}

.mono-insurance {
  display: flex;
  align-items: center;
  margin-right: 16px;
  padding: 8px 16px;
  gap: 9px;
  background: #f1f5f9;
  border-radius: 4px;
  min-width: 82px;
  p {
    margin-bottom: 0;
  }
}

.sub-title {
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  color: #0f1734;
}

.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  img {
    border-radius: 0.5em;
    max-width: 150px;
    max-height: 150px;
  }

  .title {
    font-size: 32px;
    font-weight: bold;
    color: #0f1734;
    line-height: 42px;
  }
  ul {
    list-style: none; /* Remove default bullets */
  }

  ul li::before {
    content: "\2022";
    font-weight: bold;
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-left: -1em;
  }

  .language {
    display: flex;
    flex-direction: row;
    white-space: nowrap;
    overflow: auto;
    margin-left: 20px;
    border-radius: 4px;
    flex-wrap: wrap;
    gap: 9px;
    .mono-language {
      margin-right: 16px;
    }
  }

  .mono-language {
    display: flex;
    align-items: center;
    margin-left: 20px;
    margin: 1em 0;
    padding: 8px 16px;
    gap: 9px;
    background: #f1f5f9;
    border-radius: 4px;
    min-width: 103px;
    img {
      width: 2em;
    }
    p {
      margin-left: 1em;
      margin-bottom: 0;
    }
  }
}

.dovemed-card-noborder {
  padding: 20px;
  background: #fff;
  box-shadow: none;
  margin-bottom: 20px;
  padding: 0px;
  img {
    border-radius: 0.5em;
    max-width: 150px;
    max-height: 150px;
  }

  .title {
    font-size: 32px;
    font-weight: bold;
    color: #0f1734;
    line-height: 42px;
  }
  ul {
    list-style: none; /* Remove default bullets */
  }

  ul li::before {
    content: "\2022";
    font-weight: bold;
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-left: -1em;
  }

  .language {
    display: flex;
    flex-direction: row;
    white-space: nowrap;
    overflow: auto;
    margin-left: 20px;
    border-radius: 4px;
    flex-wrap: wrap;
    gap: 9px;
    .mono-language {
      margin-right: 16px;
    }
  }

  .hosp-afflilated {
    padding: 24px;
    gap: 24px;
    min-height: 178px;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    margin-bottom: 0px;
    justify-content: space-between;
  }
  .hospital_picture {
    width: 70px;
    height: 70px;
    border-radius: 50% !important;
  }

  .hosp-name {
    max-width: 213.5px;
    text-align: left;
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    color: #0f1734;

    .tag_name {
      font-weight: 700;
      font-size: 12px;
      line-height: 14px;
      text-align: center;
      margin-bottom: 0px;
    }
  }
  .hospital_tag {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 4px;
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    margin-bottom: 0px;
  }

  .view-profile {
    padding: 12px 24px;

    width: 126px;
    height: 48px;
    border-radius: 6px;
  }
  .mono-language {
    display: flex;
    align-items: center;
    margin-left: 20px;
    margin: 1em 0;
    padding: 8px 16px;
    gap: 9px;
    background: #f1f5f9;
    border-radius: 4px;
    min-width: 103px;
    img {
      width: 2em;
    }
    p {
      margin-left: 1em;
      margin-bottom: 0;
    }
  }
}
.state {
  overflow: auto;
  gap: 24px;
  flex-wrap: wrap;
  .state-license {
    background: #f1f5f9;
    border-radius: 6px;
    flex-shrink: 0;

    @media screen and (max-width: 769px) {
      width: 100% !important;
    }
    .location {
      font-size: 12px;
      line-height: 30px;
      font-weight: bold;
      color: #062b54;
      min-width: 108px !important;
    }

    &--status {
      .left {
        font-size: 12px;
        font-weight: bold;
        color: #9ba9b9;
        line-height: 30px;
      }
      .right {
        padding-left: 13px;
        .status-circle {
          width: 10px;
          height: 10px;
          border-radius: 50%;
        }

        .status-state {
          padding-left: 5px;
          font-size: 10px;
          line-height: 24px;
        }
      }
    }
  }
}
.board-certification {
  width: 100%;
  min-height: 112px;
  border-radius: 6px;
  border: 1px solid #e6e9ed;
  display: flex;
  padding-left: 20px;
}

.right {
  display: flex;
  height: 100%;
  margin-left: 30px;
  justify-content: center;
  padding: 24px 0px;
  gap: 17px;
  flex-direction: column;
  @media screen and (max-width: 900px) {
    margin-left: 15px;
    overflow: auto;
  }
  span b {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 0px;
    width: 100%;
  }

  span {
    @media screen and (max-width: 900px) {
      font-size: 12px;
      line-height: 20px;
    }
  }

  b {
    @media screen and (max-width: 900px) {
      font-size: 12px;
      line-height: 20px;
    }
  }
}

.left {
  width: 105px;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 16px 0px;

  @media screen and (max-width: 900px) {
    width: 80px;
    flex-shrink: 0;
  }

  .img-back {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background: #f2f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 900px) {
      width: 65px;
      height: 65px;
    }
  }

  img {
    max-height: 73px !important;
    max-width: 73px !important;
    transform: scale(0.7) translate(10%);
  }
}
.insurance-sub {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #647490;
  margin-top: 24px;
}

.divider {
  width: 1px;
  background: #e6e9ed;
  height: auto;
}

.mono-area {
  margin-right: 10px;
  border-radius: 6px;
  background-color: rgba(6, 43, 84, 0.05);
  padding: 20px;
  min-width: 180px;
  @media screen and (max-width: 600px) {
    // min-width: 159px;
    margin-right: 0px;
    min-width: 0;
    // flex-basis: 48%;
    flex-basis: 100%;
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }
  img {
    width: 30px;
    height: 30px;
  }
  p {
    margin-top: 10px;
    margin-bottom: 0;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 24px;
    text-transform: capitalize;
    @media screen and (max-width: 600px) {
      margin-top: 0px;
    }
  }
}

a.noUnderline,
.noUnderline {
  cursor: auto;
  &:hover {
    text-decoration: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Doctor/DoctorAbout.vue